import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

// Reuses routes the same way as the default strategy, except during a reload, when every route is
// recreated so that its components initialize again.
@Injectable()
export class ReloadRouteReuseStrategy extends BaseRouteReuseStrategy {
  reloading = false;

  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return !this.reloading && super.shouldReuseRoute(future, curr);
  }
}
